import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IDataset } from 'app/shared/model/dataset.model';
import { getEntities as getDatasets } from 'app/entities/dataset/dataset.reducer';
import { IAdverseOutcomePathway } from 'app/shared/model/adverse-outcome-pathway.model';
import { getEntity, updateEntity, createEntity, reset } from './adverse-outcome-pathway.reducer';

export const AdverseOutcomePathwayUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const datasets = useAppSelector(state => state.dataset.entities);
  const adverseOutcomePathwayEntity = useAppSelector(state => state.adverseOutcomePathway.entity);
  const loading = useAppSelector(state => state.adverseOutcomePathway.loading);
  const updating = useAppSelector(state => state.adverseOutcomePathway.updating);
  const updateSuccess = useAppSelector(state => state.adverseOutcomePathway.updateSuccess);

  const handleClose = () => {
    navigate('/adverse-outcome-pathway');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDatasets({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  // eslint-disable-next-line complexity
  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }

    const entity = {
      ...adverseOutcomePathwayEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...adverseOutcomePathwayEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="coconApp.adverseOutcomePathway.home.createOrEditLabel" data-cy="AdverseOutcomePathwayCreateUpdateHeading">
            <Translate contentKey="coconApp.adverseOutcomePathway.home.createOrEditLabel">Create or edit a AdverseOutcomePathway</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="adverse-outcome-pathway-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('coconApp.adverseOutcomePathway.name')}
                id="adverse-outcome-pathway-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/adverse-outcome-pathway" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AdverseOutcomePathwayUpdate;
